export default function RelatedList() {
  return <h3>This is RelatedList Page</h3>;
}
